import { CSSObject } from '@chakra-ui/react';

export const Wrapper: CSSObject = {
  display: ['none', null, 'flex'],
  justifyContent: 'center',
  mb: [null, null, '72'],
};

export const TextItem: CSSObject = {
  maxW: '261px',
  color: 'white',
  textAlign: 'center',
  fontSize: 'xs',
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 'normal',
  span: { color: 'gamma.400', fontWeight: 'bold' },
};

export const LinkItem: CSSObject = {};
